import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { PresentationListResponse } from '../models/presentation.model';
import { DownloadUrlResponse } from '../models/download.model';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class PresentationService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = environment.apiUrl;

  list(page: number, perPage: number): Observable<PresentationListResponse> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('per_page', perPage.toString());

    return this.http.get<PresentationListResponse>(`${this.apiUrl}/api/presentations`, { params });
  }

  /**
   * Fetch the presigned download URL through the authenticated HttpClient path
   * (the auth interceptor attaches the Cognito token) and open it in a new tab.
   * A bare `window.open` to the endpoint would bypass the interceptor and be
   * rejected by the BFF with a 401 (missing authorization header).
   */
  download(id: string): Observable<DownloadUrlResponse> {
    return this.http
      .get<DownloadUrlResponse>(`${this.apiUrl}/api/presentations/${id}/download`)
      .pipe(tap(({ url }) => window.open(url, '_blank')));
  }
}
